
import React from 'react';
import { TableRow, TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { Trash } from 'lucide-react';
import { RevenueSplit } from '@/hooks/license/resellerPlans/types';

interface RevenueSplitTableRowProps {
  split: RevenueSplit;
  handleUpdateMasterPercentage: (id: string, value: number) => void;
  handleUpdateResellerPercentage: (id: string, value: number) => void;
  onUpdateRevenueSplit: (id: string, updates: Partial<RevenueSplit>) => void;
  onDeleteRevenueSplit: (id: string) => void;
}

const RevenueSplitTableRow: React.FC<RevenueSplitTableRowProps> = ({
  split,
  handleUpdateMasterPercentage,
  handleUpdateResellerPercentage,
  onUpdateRevenueSplit,
  onDeleteRevenueSplit
}) => {
  return (
    <TableRow key={split.id}>
      <TableCell>
        {split.volumeThreshold === 0 
          ? 'Base Tier' 
          : `$${split.volumeThreshold.toLocaleString()} and above`}
      </TableCell>
      <TableCell>
        <Input 
          type="number"
          value={split.masterLicensePercentage} 
          onChange={(e) => handleUpdateMasterPercentage(split.id, parseInt(e.target.value))}
          className="w-20"
        />
      </TableCell>
      <TableCell>
        <Input 
          type="number"
          value={split.resellerPercentage} 
          onChange={(e) => handleUpdateResellerPercentage(split.id, parseInt(e.target.value))}
          className="w-20"
        />
      </TableCell>
      <TableCell>
        <Switch 
          checked={split.isActive} 
          onCheckedChange={(checked) => onUpdateRevenueSplit(split.id, { isActive: checked })}
        />
      </TableCell>
      <TableCell>
        <Button variant="ghost" size="icon" onClick={() => onDeleteRevenueSplit(split.id)}>
          <Trash className="h-4 w-4 text-red-500" />
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default RevenueSplitTableRow;
